import { useTranslations } from 'next-intl'

import { Form } from '@/shared/ui'

type Props = {
  placeholder?: string
  readOnly?: boolean
  disabled?: boolean
}

export const PasswordConfirmField = ({
  placeholder,
  readOnly = false,
  disabled = false,
}: Props) => {
  const t = useTranslations('account')

  return (
    <Form.Field name="passwordConfirm" readOnly={readOnly} disabled={disabled}>
      <Form.Label className="font-medium text-black">
        {t('confirm_password_label')}
      </Form.Label>
      <Form.PasswordField
        placeholder={placeholder || t('confirm_password_placeholder')}
        fullWidth
        readOnly={readOnly}
        autoComplete="new-password"
      />
      <Form.Message />
    </Form.Field>
  )
}
